import React from "react";

const TICKERS = [
  { symbol: "BIST 100", price: "10.247,32", change: "+1,24%", up: true },
  { symbol: "USD/TRY", price: "42,18", change: "+0,32%", up: true },
  { symbol: "EUR/TRY", price: "45,76", change: "-0,15%", up: false },
  { symbol: "ALTIN/GR", price: "4.218", change: "+0,89%", up: true },
  { symbol: "BTC", price: "98.450", change: "+2,11%", up: true },
  { symbol: "THYAO", price: "287,50", change: "+3,42%", up: true },
  { symbol: "ASELS", price: "84,15", change: "+1,77%", up: true },
  { symbol: "GARAN", price: "118,40", change: "-0,42%", up: false },
  { symbol: "EREGL", price: "52,30", change: "+2,05%", up: true },
  { symbol: "TUPRS", price: "176,80", change: "+0,68%", up: true },
];

export default function MarketTicker() {
  const items = [...TICKERS, ...TICKERS];
  return (
    <section
      className="relative bg-[#0a1230] border-y border-white/5 py-4 overflow-hidden"
      data-testid="market-ticker"
      aria-label="Örnek piyasa verileri"
    >
      <div className="ticker-mask">
        <div className="flex gap-12 whitespace-nowrap animate-ticker">
          {items.map((t, i) => (
            <div
              key={i}
              className="flex items-center gap-3 shrink-0"
              data-testid={`ticker-item-${t.symbol.replace(/\s/g, "")}`}
            >
              <span className="text-[#94a3b8] text-xs tracking-[0.18em] uppercase">
                {t.symbol}
              </span>
              <span className="text-white font-medium text-sm">{t.price}</span>
              <span
                className={`text-xs ${t.up ? "arrow-up" : "arrow-down"}`}
              >
                {t.up ? "▲" : "▼"} {t.change}
              </span>
            </div>
          ))}
        </div>
      </div>
      <div className="text-center mt-2 text-[10px] text-[#64748b] tracking-wide">
        * Veriler örnek amaçlıdır, gerçek zamanlı yatırım kararı için kullanılamaz.
      </div>
    </section>
  );
}
